import { render } from "./addButton.vue?vue&type=template&id=0c5e976f"
import script from "./addButton.vue?vue&type=script&lang=js"
export * from "./addButton.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__